import React from 'react'
import { motion } from 'framer-motion'
import { styles } from '../styles';
import { services } from '../data/alldata';
// import { services } from '../constants/index';
import ServicesItem from '../component/Item/ServicesItem'
import StarsCanvas from '../3d/Stars';



const textVariant = () => {
  return {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };
};

const fadeIn = (direction = "", type = "spring", delay = 0.1, duration = 1) => {
  return {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { delay, duration } },
  };
};

const About =  React.forwardRef((props, ref) => {
  return (

  <div   ref={ref} className="relative w-full h-auto mx-auto  bg-center"
id='about'
>
  
      <motion.div
  variants={textVariant()}
  initial="hidden"
  animate="visible"
  className="flex flex-col items-center justify-center text-center"
>
  
  <h2 className="text-black text-[69px] font-bold">About <span className="text-[#fff000]"> Me</span></h2>
  
</motion.div>

<motion.p
  initial={{opacity:0.2,y:50}}
  transition={{duration:1}}
  whileInView={{opacity:1,y:0}}
  viewport={{once:true}}
  className="mt-4 text-gray-600 text-[20px] max-w-3xl leading-relaxed text-center mx-auto"
>
  Passionate about the world of the web, with significant experience in website development. 
  As an IT expert, web integration, front-end and back-end development, and web design 
  are part of my daily life. Today, I am investing in the creation of applications 
  with an agency working on multiple projects.
</motion.p>

      <div className=" mt-20 flex flex-wrap gap-24   items-center justify-center text-center">
         {services.map((service,index)=>(
          <ServicesItem key={index} service={service} />
      
        ))} 

      </div>
    </div>

  );
});

export default About
